<template>
	<div class="modal">
		<div class="row">
			<div class="col-sm-12 col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40 central">
			<div class="col-sm-12 col-md-12">
				<p class="textGrey textLg textCenter margin-b5">Getting in touch</p>
				<p class="textCenter">We aim to get back to you within 24 hours.</p>
			</div>
		</div>
		<div class="row margin-b50 central">
			<div class="col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4 w90 central-w">
				<div class="card formPanel w90 central-w">
					<div class="content">
						<div class="row margin-b20 w90">
							<div class="col-sm-12 col-md-12">
								<p class="formTitle textCenter">SELECT REASON</p>
							</div>
						</div>
						<div class="row margin-b20 central-w w-full">
							<div class="w-full">
								<div class="formGroup withIcon central-w w-full">
									<select v-model="selectedReason">
										<option value="" class="disabled" disabled>Choose from options</option>
										<option value="Support Request">Support Request</option>
										<option value="General Enquiry">General Enquiry</option>
										<option value="Feedback">Feedback</option>
									</select>
									<span class="fa-light fa-chevron-down"></span>
								</div>
							</div>
						</div>
						<div v-if="selectedReason" class="margin-b20">
							<p class="formTitle margin-b10">Enter your message</p>
							<div class="formGroup withIcon">
								<textarea
									v-model="message"
									class="w-full rounded-sm px-2.5 py-2 text-[14px] transition"
									rows="12"
								></textarea>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row margin-b20">
			<div class="w-full">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg grey" @click="close()">Cancel</a></li>
					<li><a class="jmiBtn btnLg green" @click="submit()">Submit</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import usersApi from '../scripts/users/users.api'

export default {
	inject: ['user', 'userRoles', 'showContactFormModal'],
	props: {
		contact: Object,
		defaultReason: {
			type: String,
			default: 'Support Request'
		}
	},

	data() {
		return {
			selectedReason: this.defaultReason,
			message: ''
		}
	},

	methods: {
		submit() {
			usersApi
				.sendEmail({
					subject: `${this.selectedReason} - Request sent from TeleFlow Portal`,
					contents: this.message
				})
				.then((result) => {
					this.close()
				})
				.catch((err) => {
					console.error(err)
					this.close()
				})
		},
		close() {
			this.showContactFormModal = false
		}
	}
}
</script>
